import { render, staticRenderFns } from "./favourite-paper-list.html?vue&type=template&id=0700ab50&scoped=true&external"
import script from "./favourite-paper-list.js?vue&type=script&lang=js&external"
export * from "./favourite-paper-list.js?vue&type=script&lang=js&external"
import style0 from "./favourite-paper-list.scss?vue&type=style&index=0&id=0700ab50&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700ab50",
  null
  
)

export default component.exports